import React, { ReactElement } from "react";
import { LightTheme } from "src/styles/theme";
import { ThemeProvider } from "styled-components";

const wrapRootElement: React.FC<{ element: ReactElement }> = ({ element }) => (
  <ThemeProvider theme={LightTheme}>{element}</ThemeProvider>
);

export default wrapRootElement;
